import { createAction } from "@reduxjs/toolkit";
import { UPDATE_SEARCH_TERM } from "../constants";

const updateSearchTerm = createAction(UPDATE_SEARCH_TERM);

export default updateSearchTerm;
